import {combineReducers} from '@reduxjs/toolkit';

import quickPanel from 'app/main/shared-components/quick-panel/store';
import auth from 'app/auth/store';
import configurations from 'app/main/configurations/store';
import schedule from 'app/main/schedule/store';
import flights from 'app/main/flights/store';
import schedules from 'app/main/schedules/store';
import employees from 'app/main/employees/store';
import customers from 'app/main/customer/store';
import account from 'app/account/store';
import navbar from 'app/main/layout/store';
import reports from 'app/main/report/store';
import appReducers from "./App";
import sales from "app/main/sales/store"
import agents from "app/main/agency/store";
import coupons from "app/main/coupons/store";
import internalSales from "app/main/sales/store/internal-sales.store";

const createReducer = combineReducers({
  auth,
  quickPanel,
  configurations,
  appReducers,
  schedule,
  flights,
  schedules,
  employees,
  customers,
  agents,
  account,
  navbar,
  reports,
  sales,
  coupons,
  internalSales,
});

export default createReducer;
